import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axios'; 

const RegisterPage = () => {

    const defaultEntities = Array.from({ length: 16 }, (_, i) => `CMH ${i + 1}`);

    const [formData, setFormData] = useState({
        username: '',
        password: '',
        entity: '' 
    });
    
    const [isCustomEntity, setIsCustomEntity] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); 
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Other selected 
        if (name === "entitySelect") {
            if (value === "OTHER") {
                setIsCustomEntity(true);
                setFormData({ ...formData, entity: '' });
            } else {
                setIsCustomEntity(false);
                setFormData({ ...formData, entity: value });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await api.post('/auth/register', formData);
            alert("Compte créé avec succès ! En attente d'approbation par l'admin.");
            navigate('/login'); 
        } catch (err) {
            console.error(err);
            const msg = err.response?.data?.message || 'Échec de l\'inscription.';
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="card p-4 shadow" style={{ width: '400px' }}>
                <h2 className="text-center mb-4 text-primary">Create Account</h2>
                
                {error && <div className="alert alert-danger">{error}</div>}
                
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">Username</label>
                        <input 
                            type="text" name="username"
                            className="form-control" 
                            onChange={handleChange} required 
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input 
                            type="password" name="password"
                            className="form-control" 
                            onChange={handleChange} required 
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Select Entity</label>
                        <select 
                            name="entitySelect"
                            className="form-select mb-2"
                            onChange={handleChange}
                            required={!isCustomEntity}
                            value={isCustomEntity ? "OTHER" : formData.entity}
                        >
                            <option value="">Choose an entity...</option>
                            {defaultEntities.map(ent => (
                                <option key={ent} value={ent}>{ent}</option>
                            ))}
                            <option value="OTHER">Other (Custom)...</option>
                        </select>

                        {/* Other selected   */}
                        {isCustomEntity && (
                            <input 
                                type="text" 
                                name="entity"
                                className="form-control mt-2 border-primary" 
                                value={formData.entity}
                                onChange={handleChange} 
                                required 
                                placeholder="Type your custom entity name"
                                autoFocus
                            />
                        )}
                    </div>

                    <button type="submit" className="btn btn-success w-100 mb-3" disabled={loading}>
                        {loading ? 'Registering...' : 'Register'}
                    </button>
                </form>

                <div className="text-center">
                    <small>Already have an account? <Link to="/login">Login here</Link></small>
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;